import { createContext } from 'react';

const ModalContext = createContext({
    showCustomModal: false,
    setShowCustomModal: () => {},
  
});

export default ModalContext;
